var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UserSubjectStatusEnum } from '@/models/UserSubject';
import { Component, Vue } from 'vue-property-decorator';
let SubjectStatusSelect = class SubjectStatusSelect extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        this.statusses = [
            UserSubjectStatusEnum.INACTIVE,
            UserSubjectStatusEnum.HIGHLIGHTED,
            UserSubjectStatusEnum.BUSY,
            UserSubjectStatusEnum.OLD,
            UserSubjectStatusEnum.CLOSED,
            UserSubjectStatusEnum.FINISHED,
            UserSubjectStatusEnum.FUTURE,
        ];
        this.statusItems = [];
        // #endregion
        // #region Async methods
        // #endregion
        // #region Getters
        // #endregion
        // #region Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle & Init
    mounted() {
        this.generateStatusItems();
    }
    // #endregion
    // #region Class methods
    generateStatusItems() {
        this.statusses.forEach((status) => {
            const label = this.$store.state.labels.find((label) => {
                return label.key === status;
            });
            this.statusItems.push({
                value: status,
                text: !label || label.value === label.key
                    ? this.$tc(`idp.status.${status}`, 2)
                    : label.value,
            });
        });
        // console.log('statusItems', this.statusItems);
        this.isLoading = false;
    }
};
SubjectStatusSelect = __decorate([
    Component({
        components: {
        //
        },
    })
], SubjectStatusSelect);
export default SubjectStatusSelect;
